<template>
  <section
    class="main-page card-tab"
    :class="{
      'card-tab--filled': pageFilled,
      'card-tab--standalone': route.path === '/card/index',
    }"
  >
    <!-- <header class="tab-header">
      <h1>{{ t('card.title') }}</h1>
      <button v-if="cards.length" type="button" class="tab-header__add" @click="goOpenCard">
        <app-image src="@/assets/images/cardImage/add_card_icon.png" alt="" />
      </button>
    </header> -->

    <AppNavBar
      :background-color="pageBackground"
      :title="t('card.title')"
      :leftArrow="true"
      :auto-back="false"
      @click-left="handleBack"
      backgroundColor="#fff"
    >
      <template #right>
        <button
          type="button"
          class="nav-contact-btn"
          @click="router.push('/mine/about')"
        >
          <AppSvgIcon name="contack_icon" size="22" color="#000" />
        </button>
      </template>
    </AppNavBar>

    <div class="card-tab__scroll">
      <div class="card-type-switch-wrap">
        <div class="card-type-switch">
          <button
            v-for="(item, index) in tabItems"
            :key="item.type"
            type="button"
            :class="{ active: activeTab === index }"
            @click="changeTab(index)"
          >
            {{ item.title }}
          </button>
        </div>
      </div>
      <van-pull-refresh v-model="refreshing" @refresh="refreshCards">
        <section v-if="!loading && cards.length" class="card-wallet">
          <!-- <button
          v-if="showInactiveEntry"
          type="button"
          class="pending-entry"
          @click="goPendingPhysicalCards"
        >
          <span>{{ t('card.hasInactiveCards') }}</span>
          <van-icon name="arrow" />
        </button> -->

          <section class="card-wallet__panel">
            <section class="current-card-bar">
              <button
                type="button"
                class="current-card-bar__trigger"
                @click="cardPickerVisible = true"
              >
                <div class="current-card-bar__left">
                  <span class="current-card-bar__icon">
                    <AppSvgIcon
                      name="bank_card"
                      size="16"
                      color="var(--wp-color-brand-1)"
                    />
                  </span>
                  <div data-strong>{{ currentCardCode }}</div>
                  <i class="current-card-bar__caret" />
                </div>
              </button>
              <div
                v-if="
                  showInactiveEntry ||
                  (activeTab === 1 &&
                    statusKey(currentCard?.status) !== 'active' &&
                    currentCardStatus)
                "
                class="current-card-bar__right"
              >
                <button
                  v-if="showInactiveEntry"
                  type="button"
                  class="current-card-bar__link"
                  @click="goPendingPhysicalCards"
                >
                  <span>{{ t("card.hasInactiveCards") }}</span>
                  <van-icon name="arrow" size="14" />
                </button>
              </div>
            </section>

            <div class="card-carousel">
              <DesktopSwipe
                ref="swipeRef"
                :loop="false"
                lazy-render
                :show-indicators="false"
                @change="onSwipeChange"
              >
                <van-swipe-item
                  v-for="(item, index) in cards"
                  :key="item.id || index"
                  class="swipeItem"
                >
                  <div class="bank-card" @click="goCardBill(item)">
                    <app-image :src="cardBackground(item)" alt="" />
                    <app-image
                      v-if="activeTab !== 1"
                      class="bank-card__logo"
                      :src="themeStore.image('img15', logo)"
                      alt=""
                    />
                    <span v-else class="course-card-label">
                      {{ t("card.courseCard") }}
                    </span>
                    <span
                      class="bank-card__bin"
                      v-if="item.cardType === 'VIRTUAL'"
                      >BIN {{ item.bin || "****" }}</span
                    >
                    <span class="bank-card__balance">
                      {{ formatBankCardBalance(item) }}
                    </span>
                    <span class="bank-card__scene">{{
                      formatCardScene(item)
                    }}</span>
                  </div>
                </van-swipe-item>
              </DesktopSwipe>

              <div v-if="cards.length > 1" class="carousel-dots">
                <i
                  v-for="(_, index) in cards"
                  :key="index"
                  :class="{ 'is-active': currentIndex === index }"
                  @click="swipeRef?.swipeTo?.(index)"
                />
              </div>
            </div>

            <div
              class="tool-line"
              v-if="cards.length"
              :class="{ 'mt-20': cards.length }"
            ></div>
            <section class="tool-grid" :class="{ 'mt-20': cards.length }">
              <div
                v-for="tool in tools"
                class="tool-grid-button"
                :key="tool.label"
                @click="handleTool(tool)"
              >
                <app-image :src="tool.icon" alt="" />
                <div class="tool-grid-label">{{ tool.label }}</div>
              </div>
            </section>
          </section>

          <section class="records-card">
            <header>
              <h2>{{ t("card.recentTrade") }}</h2>
              <button
                type="button"
                class="records-card__more"
                @click="goCardBill(currentCard)"
              >
                <span>{{ t("card.viewAll") }}</span>
                <van-icon name="arrow" size="12" />
              </button>
            </header>

            <div v-if="!records.length" class="records-empty">
              <app-image src="@/assets/images/emptydata_gray.png" alt="" />
              <p>{{ t("card.noTradeEmpty") }}</p>
            </div>
            <button
              v-for="item in records"
              v-else
              :key="item.id || item.createTime"
              class="record-item"
              type="button"
              @click="openTrade(item)"
            >
              <div>
                <div data-strong>{{ item.typeMsg || item.remark || "--" }}</div>
                <span>{{ formatTime(item.createTime) }}</span>
              </div>
              <div class="record-item__right">
                <div class="record-item__amount">
                  <div
                    data-strong
                    :class="{ positive: Number(item.amount || 0) > 0 }"
                  >
                    {{ Number(item.amount || 0) > 0 ? "+" : ""
                    }}{{ item.amount || "0" }} {{ item.symbol || "" }}
                  </div>
                  <span>{{ statusText(item.status) }}</span>
                </div>
                <van-icon class="record-item__arrow" name="arrow" size="14" />
              </div>
            </button>
          </section>
        </section>

        <section v-else-if="showPendingActivation" class="pending-empty">
          <section class="pending-empty__cards">
            <van-swipe
              ref="pendingSwipeRef"
              :loop="true"
              :show-indicators="false"
              @change="onPendingSwipeChange"
            >
              <van-swipe-item v-for="item in pendingCards" :key="item">
                <article class="pending-card">
                  <app-image
                    :src="themeStore.image('img16', cardThree)"
                    alt=""
                  />
                  <span class="course-card-label">{{
                    t("card.courseCard")
                  }}</span>
                  <div class="pending-card__status">
                    <span class="pending-card__status-dot" />
                    <span>{{ t("card.inactive") }}</span>
                  </div>
                </article>
              </van-swipe-item>
            </van-swipe>

            <div v-if="pendingCards.length > 1" class="carousel-dots">
              <i
                v-for="(_, index) in pendingCards"
                :key="index"
                :class="{ 'is-active': pendingCardIndex === index }"
                @click="pendingSwipeRef?.swipeTo?.(index)"
              />
            </div>
          </section>

          <section class="pending-empty__notice">
            <div class="pending-empty__notice-head">
              <span class="pending-empty__notice-icon" aria-hidden="true"
                >i</span
              >
              <div data-strong>{{ t("card.physicalInstruction") }}</div>
            </div>
            <ul class="pending-empty__tips">
              <li>{{ t("card.pendingNotice1") }}</li>
              <li>{{ t("card.pendingNotice2") }}</li>
              <li>{{ t("card.pendingNotice3") }}</li>
            </ul>
          </section>

          <van-button
            icon-prefix="icon"
            round
            :icon="cardActionIcon"
            block
            type="primary"
            class="pending-empty__primary"
            @click="router.push('/wallet/physical-active')"
          >
            <span>{{ t("wallet.activatePhysicalCard") }}</span>
          </van-button>

          <van-button
            round
            block
            plain
            type="primary"
            class="pending-empty__support"
            @click="router.push('/mine/about')"
          >
            <template #icon>
              <AppSvgIcon
                name="contack_icon"
                size="20"
                color="var(--wp-color-brand-1)"
              />
            </template>
            <span>{{ t("card.contactSupport") }}</span>
          </van-button>
        </section>

        <section v-else-if="!loading" class="empty-card">
          <app-image
            :src="
              activeTab === 0
                ? themeStore.image('img13', virtualEmpty)
                : themeStore.image('img14', physicalEmpty)
            "
            alt=""
          />
          <app-image
            class="logo"
            :src="themeStore.image('img15', logo)"
            alt=""
          />
          <h2>{{ tabItems[activeTab].title }}</h2>
          <p>
            {{
              activeTab === 0 ? t("card.virtualDesc") : t("card.physicalDesc")
            }}
          </p>
          <van-button
            round
            block
            class="empty-card__action"
            @click="goOpenCard"
            >{{ t("card.applyCard") }}</van-button
          >
        </section>

        <van-skeleton v-else title :row="6" />
      </van-pull-refresh>
    </div>

    <button
      v-if="cards.length || showPendingActivation"
      type="button"
      class="floating-add-btn"
      @click="openCardDetailsShortcut"
    >
      <AppSvgIcon name="add_card_icon" size="60" color="#fff" />
    </button>

    <van-popup v-model:show="cardPickerVisible" position="bottom" round>
      <section class="card-picker">
        <header class="card-picker__header">
          <div data-strong>{{ t("card.myCards") }}</div>
          <button
            type="button"
            class="card-picker__close"
            @click="cardPickerVisible = false"
          >
            <app-image
              class="app-cancel-icon"
              src="@/assets/images/cancel_gray.png"
              alt=""
            />
          </button>
        </header>
        <button
          v-for="(item, index) in cards"
          :key="item.id || index"
          type="button"
          class="card-picker__item"
          :class="{ active: currentIndex === index }"
          @click="selectCard(index)"
        >
          <div class="card-picker__item-left">
            <div data-strong>{{ formatCardCode(item) }}</div>
          </div>
          <div class="card-picker__item-right">
            <div data-strong>${{ item.balance?.available || "0.00" }}</div>
            <AppSvgIcon
              v-if="currentIndex === index"
              class="card-picker__check"
              name="icon"
              size="16"
              color="var(--wp-color-theme)"
            />
            <i v-else class="card-picker__check card-picker__check--empty" />
          </div>
        </button>
      </section>
    </van-popup>

    <van-popup
      v-model:show="showKycDialog"
      class="kyc-dialog-popup"
      :close-on-click-overlay="false"
    >
      <section class="kyc-dialog">
        <AppSvgIcon
          class="kyc-dialog__icon"
          color="#fff"
          name="kyc_dialog_icon"
          size="50"
        />
        <button type="button" class="kyc-dialog__close" @click="closeKycDialog">
          <app-image
            class="app-cancel-icon"
            src="@/assets/images/cancel_gray.png"
            alt=""
          />
        </button>
        <h2>{{ t("card.kycDialogTitle") }}</h2>
        <p>{{ t("card.kycDialogDesc") }}</p>
        <div class="kyc-dialog__actions">
          <button
            type="button"
            class="kyc-dialog__cancel"
            @click="closeKycDialog"
          >
            {{ t("common.cancel") }}
          </button>
          <button
            type="button"
            class="kyc-dialog__confirm"
            @click="confirmKycDialog"
          >
            {{ t("card.kycDialogAction") }}
          </button>
        </div>
      </section>
    </van-popup>

    <PayPasswordPopup
      v-model:show="showInfoPasswordDialog"
      v-model:password="infoPassword"
      :title="t('auth.verifyWalletPassword')"
      :placeholder="t('auth.enterPassword')"
      :confirm-text="t('common.confirm')"
      :forgot-text="t('auth.forgotPasswordRecovery')"
      show-forgot
      :confirm-disabled="!infoPassword.trim()"
      @confirm="confirmCardInfoPassword"
      @cancel="resetCardInfoPasswordPopup"
      @closed="resetCardInfoPasswordPopup"
      @forgot="goForgotPassword"
    />
  </section>
</template>

<script setup>
import { computed, nextTick, reactive, ref, watch } from "vue";
import { closeToast, showFailToast, showLoadingToast, showToast } from "vant";
import { useI18n } from "vue-i18n";
import { useRouter, useRoute } from "vue-router";
import PayPasswordPopup from "@/components/PayPasswordPopup.vue";
import DesktopSwipe from "@/components/DesktopSwipe.vue";
import { payPwdCheck } from "@/api/auth";
import { pcCardCreatePre } from "@/api/card";
import { useCardStore } from "@/stores/card";
import { useCardBillStore } from "@/stores/card-bill";
import { useProfileStore } from "@/stores/profile";
import { getDeviceId } from "@/utils/device";
import { getRouteState, navigateWithState } from "@/utils/route-state";
import { useThemeStore } from "@/stores/theme";
import { safeBack } from "@/utils/navigation";
import { saveCardInfoAccess } from "@/utils/walletSession";
import topupIcon from "@/assets/images/cardImage/mycards_icon_1.png";
import withdrawIcon from "@/assets/images/cardImage/mycards_icon_2.png";
import atmIcon from "@/assets/images/cardImage/mycards_icon_3.png";
import infoIcon from "@/assets/images/cardImage/mycards_icon_4.png";
import benefitIcon from "@/assets/images/cardImage/mycards_icon_5.png";
import unbindIcon from "@/assets/images/cardImage/mycards_icon_6.png";
import instructionIcon from "@/assets/images/cardImage/mycards_icon_7.png";
import virtualEmpty from "@/assets/images/SVG/img13.png";
import physicalEmpty from "@/assets/images/SVG/img14.png";
import logo from "@/assets/images/SVG/img15.png";
import cardOne from "@/assets/images/cardImage/card_one.png";
import cardTwo from "@/assets/images/cardImage/card_two.png";
import cardThree from "@/assets/images/SVG/img16.png";
import cardActionIcon from "@/assets/images/cardImage/card_icon.png";

const { t } = useI18n();
const router = useRouter();
const route = useRoute();
const cardStore = useCardStore();
const cardBillStore = useCardBillStore();
const profileStore = useProfileStore();
const themeStore = useThemeStore();

const activeTab = ref(0);
const refreshing = ref(false);
const cardPickerVisible = ref(false);
const swipeRef = ref(null);
const pendingSwipeRef = ref(null);
const pendingCardIndex = ref(0);
const silentLoadingConfig = reactive({ meta: { showLoading: true } });
const showInfoPasswordDialog = ref(false);
const showKycDialog = ref(false);
const infoPassword = ref("");
const pendingInfoQuery = ref(null);
const pageState = computed(() => getRouteState(route, "home-card", {}));
const loadCardsSequence = ref(0);

const tabItems = computed(() => [
  { title: t("card.virtualCard"), type: 2 },
  { title: t("card.physicalCard"), type: 1 },
]);

const currentType = computed(() => tabItems.value[activeTab.value].type);
const cards = computed(() => cardStore.cardsByType(currentType.value));
const records = computed(() => cardStore.recordsByType(currentType.value));
const currentIndex = computed(() =>
  cardStore.currentIndexByType(currentType.value),
);
const currentCard = computed(() =>
  cardStore.currentCardByType(currentType.value),
);
const loading = computed(() => cardStore.loadingByType(currentType.value));
const unActiveCount = computed(() => cardStore.unActiveCount);
const pendingCards = computed(() =>
  Array.from({ length: unActiveCount.value }, (_, index) => index + 1),
);
const showPendingActivation = computed(
  () =>
    activeTab.value === 1 &&
    !loading.value &&
    !cards.value.length &&
    unActiveCount.value > 0,
);
const showInactiveEntry = computed(
  () =>
    activeTab.value === 1 && cards.value.length > 0 && unActiveCount.value > 0,
);
const pageFilled = computed(
  () => cards.value.length > 0 || showPendingActivation.value,
);
const pageBackground = computed(() =>
  pageFilled.value ? "#f5f5f5" : "#ffffff",
);
const currentCardCode = computed(() => formatCardCode(currentCard.value));
const currentCardStatus = computed(() =>
  normalizeStatus(currentCard.value?.status),
);
const tools = computed(() => [
  { label: t("card.transferIn"), icon: topupIcon, action: "topup" },
  { label: t("card.transferOut"), icon: withdrawIcon, action: "withdraw" },
  { label: t("card.cardInfo"), icon: infoIcon, action: "info" },
  { label: t("card.benefit"), icon: benefitIcon, action: "benefit" },
  { label: t("card.unbindCard"), icon: unbindIcon, action: "unbind" },
  ...(activeTab.value === 1
    ? [{ label: t("card.atmPassword"), icon: atmIcon, action: "atm" }]
    : []),
  {
    label: t("card.useInstruction"),
    icon: instructionIcon,
    action: "instruction",
  },
]);
const routeTab = computed(() =>
  String(pageState.value?.tab || "").toLowerCase(),
);

function handleBack() {
  const backTo = String(pageState.value?.backTo || "").trim();
  if (backTo) {
    router.replace(backTo);
    return;
  }

  safeBack(router, "/home/index");
}

function resolveTabIndex(value) {
  return value === "physical" ? 1 : 0;
}

function changeTab(index) {
  const nextTab = index === 1 ? "physical" : undefined;
  const currentTab = routeTab.value || undefined;
  const changed = activeTab.value !== index;
  activeTab.value = index;
  if (currentTab !== nextTab) {
    if (changed) {
      loadCards();
    }
    navigateWithState(router, route.path, {
      namespace: "home-card",
      replace: true,
      payload: {
        ...pageState.value,
        tab: nextTab || "",
      },
    });
    return;
  }
  if (!changed) return;
  loadCards();
}

function onSwipeChange(index) {
  cardStore.setCurrentIndex(currentType.value, index);
  cardStore.clearRecords(currentType.value);
  Object.assign(silentLoadingConfig, { meta: { showLoading: false } });
  loadRecords();
}

function onPendingSwipeChange(index) {
  pendingCardIndex.value = index;
}

function formatCardCode(card) {
  if (!card) return "****-****-****-****";
  const bin = String(card.bin || "****").slice(0, 4);
  const last4 = String(card.last4 || "****");
  return `${bin}-****-****-${last4}`;
}

async function syncSwipePosition() {
  await nextTick();
  swipeRef.value?.swipeTo?.(currentIndex.value);
}

async function selectCard(index) {
  cardStore.setCurrentIndex(currentType.value, index);
  cardPickerVisible.value = false;
  await syncSwipePosition();
  await loadRecords();
}

function cardBackground(card) {
  return card?.image || cardOne;
}

function formatCardScene(card) {
  const scene = String(card?.scene || card?.cardName || "").trim();
  if (!scene) return t("card.prepaidCard");
  return `${scene} ${t("card.prepaidCard")}`.trim();
}

function formatBankCardBalance(card) {
  const value = card?.balance?.available;
  const currency = card?.balance?.currency;
  const text = String(value ?? "0.00").trim();
  return `${text || "0.00"}  ${currency}`;
}

function normalizeStatus(status) {
  const value = String(status || "").toLowerCase();
  if (value === "active") return t("card.inUse");
  if (value === "inactive") return t("card.inactive");
  if (value === "frozen") return t("card.frozen");
  if (value === "pending" || value === "control") return t("card.processing");
  return status ? String(status) : "";
}

function statusKey(status) {
  const value = String(status || "").toLowerCase();
  if (value === "active") return "active";
  if (value === "inactive") return "inactive";
  if (value === "frozen") return "frozen";
  if (value === "pending" || value === "control") return "processing";
  return "default";
}

function statusText(status) {
  if (Number(status) === 1) return t("card.success");
  if (Number(status) === 2) return t("card.failed");
  if (Number(status) === 3) return t("card.processing");
  return "";
}

function closeKycDialog() {
  showKycDialog.value = false;
}

function confirmKycDialog() {
  closeKycDialog();
  router.push("/card/kyc");
}

function formatTime(timestamp) {
  if (!timestamp) return "";
  const value = Number(timestamp);
  const date = new Date(value < 10000000000 ? value * 1000 : value);
  const pad = (num) => String(num).padStart(2, "0");
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}`;
}

async function goOpenCard() {
  if (!profileStore.platformAddress) {
    router.replace("/login");
    return;
  }

  showLoadingToast({
    message: t("common.loading"),
    forbidClick: true,
    duration: 0,
  });
  try {
    const result = await pcCardCreatePre({
      address: profileStore.platformAddress,
    });
    const holderStatus = Number(result?.holderStatus || 0);
    if (holderStatus === 3) {
      openCardDetailsShortcut();
      return;
    }
    if (
      holderStatus === 2 ||
      holderStatus === 4 ||
      (holderStatus === 1 && String(result?.reason || "").trim())
    ) {
      navigateWithState(router, "/card/kyc/result", {
        namespace: "card-kyc-result",
        payload: {
          holderStatus: String(holderStatus),
          reason: result?.reason || "",
        },
      });
      return;
    }
    showKycDialog.value = true;
  } catch (error) {
    showFailToast(error.message || t("common.retryLater"));
  } finally {
    closeToast();
  }
}

function openCardDetailsShortcut() {
  if (!profileStore.platformAddress) {
    router.replace("/login");
    return;
  }
  navigateWithState(router, "/wallet/open-card", {
    namespace: "card-open",
    payload: { type: "2" },
  });
}

function goPendingPhysicalCards() {
  navigateWithState(router, "/card/physical-pending", {
    namespace: "physical-card-pending",
    payload: {
      from: "my_cards",
    },
  });
}

function goCardBill(card) {
  if (!card?.id) return;
  navigateWithState(router, "/card/bill", {
    namespace: "card-bill",
    payload: { cardId: card.id },
  });
}

function handleTool(item) {
  if (!currentCard.value?.id) return;
  if (
    (item.action === "topup" || item.action === "withdraw") &&
    currentCard.value.channelType === "SSSPAY"
  ) {
    showFailToast(t("card.oldCardTransferTip"));
    return;
  }
  if (
    (item.action === "info" || item.action === "atm") &&
    String(currentCard.value.status || "").toLowerCase() !== "active"
  ) {
    showFailToast(t("card.cardProcessingWait"));
    return;
  }
  const query = {
    cardId: currentCard.value.id,
    network: currentCard.value.network || "",
    bin: currentCard.value.bin || "",
    last4: currentCard.value.last4 || "",
    channelType: currentCard.value.channelType || "",
    balanceAvailable: currentCard.value.balance?.available || "",
    balanceCurrency: currentCard.value.balance?.currency || "",
    cardType: currentType.value,
    status: currentCard.value.status || "",
  };
  if (item.action === "topup") {
    navigateWithState(router, "/card/transfer", {
      namespace: "card-transfer",
      payload: { ...query, mode: "in" },
    });
    return;
  }
  if (item.action === "withdraw") {
    navigateWithState(router, "/card/transfer", {
      namespace: "card-transfer",
      payload: { ...query, mode: "out" },
    });
    return;
  }
  if (item.action === "benefit") {
    navigateWithState(router, "/card/detail", {
      namespace: "card-detail",
      payload: {
        cardId: currentCard.value.id,
        channelType: currentCard.value.channelType || "",
        cardType: currentType.value,
        network: currentCard.value.network || "",
      },
    });
    return;
  }
  if (item.action === "unbind") {
    if (currentCard.value.channelType === "SSSPAY") {
      showFailToast(t("card.oldCardServiceUpgradeNotice"));
      return;
    }
    navigateWithState(router, "/card/unbind/info", {
      namespace: "card-unbind-info",
      payload: {
        ...query,
        cardInfo: currentCard.value,
      },
    });
    return;
  }
  if (item.action === "info") {
    pendingInfoQuery.value = query;
    infoPassword.value = "";
    showInfoPasswordDialog.value = true;
    return;
  }
  if (item.action === "atm") {
    navigateWithState(
      router,
      {
        path: "/card/atm",
        state: { pin: currentCard.value.pin || "" },
      },
      {
        namespace: "card-atm",
        payload: { ...query, pin: currentCard.value.pin || "" },
      },
    );
    return;
  }
  if (item.action === "instruction") {
    navigateWithState(router, "/card/use-instruction", {
      namespace: "card-use-instruction",
      payload: {
        cardType: currentType.value,
      },
    });
    return;
  }
  showToast(t("card.cardSensitiveTodo"));
}

function resetCardInfoPasswordPopup() {
  infoPassword.value = "";
  showInfoPasswordDialog.value = false;
  pendingInfoQuery.value = null;
}

async function confirmCardInfoPassword() {
  const payPwd = String(infoPassword.value || "").trim();
  if (!payPwd) {
    showFailToast(t("auth.enterPassword"));
    return;
  }

  const result = await payPwdCheck({ payPwd });
  if (!result) {
    showFailToast(t("auth.passwordError"));
    return;
  }

  const query = pendingInfoQuery.value;
  if (!query?.cardId) {
    resetCardInfoPasswordPopup();
    return;
  }

  saveCardInfoAccess(query.cardId);
  resetCardInfoPasswordPopup();
  navigateWithState(router, "/card/info", {
    namespace: "card-info",
    payload: query,
  });
}

function goForgotPassword() {
  resetCardInfoPasswordPopup();
  router.push("/auth/forgot-pay-password");
}

function openTrade(item) {
  if (!item) return;
  cardBillStore.setCurrentTrade(item);
  router.push("/card/bill/detail");
}

async function loadRecords() {
  if (!currentCard.value?.id) {
    await cardStore.fetchRecentRecords(
      {
        address: profileStore.platformAddress || null,
        cardType: currentType.value,
        cardId: "",
      },
      silentLoadingConfig,
    );
    return;
  }

  try {
    await cardStore.fetchRecentRecords(
      {
        address: profileStore.platformAddress || null,
        cardType: currentType.value,
        cardId: currentCard.value.id,
        pageNum: 1,
        pageSize: 10,
        lastDays: "180",
      },
      silentLoadingConfig,
    );
  } catch (error) {
    showFailToast(error.message || t("common.retryLater"));
  }
}

async function loadUnActiveCount() {
  try {
    await cardStore.fetchUnActiveCount();
  } catch (error) {
    showFailToast(error.message || t("common.retryLater"));
  }
}

async function loadCards() {
  const requestId = ++loadCardsSequence.value;
  const cardType = currentType.value;

  try {
    await cardStore.fetchCards({
      address: profileStore.platformAddress || null,
      cardType,
      deviceToken: getDeviceId(),
    });
    if (requestId !== loadCardsSequence.value) {
      return;
    }

    if (cardType === currentType.value) {
      await syncSwipePosition();
      if (requestId !== loadCardsSequence.value) {
        return;
      }
      await Promise.allSettled([loadRecords(), loadUnActiveCount()]);
    } else {
      await loadUnActiveCount();
    }

    Object.assign(silentLoadingConfig, { meta: { showLoading: true } });
  } catch (error) {
    showFailToast(error.message || t("common.retryLater"));
  } finally {
    refreshing.value = false;
  }
}

async function refreshCards() {
  Object.assign(silentLoadingConfig, { meta: { showLoading: false } });
  await loadCards();
}

watch(
  routeTab,
  (value, oldValue) => {
    const nextIndex = resolveTabIndex(value);
    const changed = activeTab.value !== nextIndex;
    activeTab.value = nextIndex;
    if (changed || oldValue === undefined) {
      loadCards();
    }
  },
  { immediate: true },
);
</script>

<style scoped lang="scss">
.main-page {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 100%;
  overflow: hidden;
  padding: env(safe-area-inset-top) 14px 0;
  background: #ffffff;
}

.card-tab--filled {
  background: #fff;
}

.card-tab--standalone {
  height: var(--app-viewport-height);
  min-height: var(--app-viewport-height);
}

.card-tab__scroll {
  flex: 1;
  min-height: 0;
  overflow: auto;
  padding-bottom: 96px;
}

.nav-contact-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 0;
  background: transparent;
}

.tab-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 58px;

  h1 {
    margin: 0;
    color: var(--wp-color-text);
    font-size: 24px;
    font-weight: 500;
  }
}

.tab-header__add {
  padding: 0;
  border: 0;
  background: transparent;

  .app-image {
    width: 44px;
    height: 44px;
  }
}

.card-type-switch-wrap {
  position: sticky;
  top: 0;
  z-index: 20;
  margin: 0 -14px;
  padding: 12px 14px;
  background: #ffffff;
  border-bottom: 1px solid #fff;
}

.card-type-switch {
  display: flex;
  padding: 3px;
  border-radius: 30px;
  background: #eaeaea;

  button {
    flex: 1;
    padding: 8px 12px;
    border: 0;
    border-radius: 30px;
    background: transparent;
    color: #000000;
    font-size: 16px;
  }

  button.active {
    background: #ffffff;
  }
}

.nav-add-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  padding: 0;
  border: 0;
  background: transparent;

  .app-image {
    width: 30px;
    height: 30px;
    object-fit: contain;
  }
}

.pending-entry {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 12px;
  padding: 12px 16px;
  border: 0;
  border-radius: 12px;
  background: #eff5ff;
  color: var(--wp-color-brand-1);

  span {
    font-size: 14px;
    font-weight: 500;
  }

  :deep(.van-icon) {
    font-size: 16px;
  }
}

.card-wallet {
  padding-bottom: 20px;
}

.card-wallet__add {
  display: flex;
  justify-content: flex-end;
  width: 100%;
  margin-top: 10px;
  padding: 0;
  border: 0;
  background: transparent;

  .app-image {
    width: 44px;
    height: 44px;
  }
}

.card-wallet__panel {
  padding: 10px 0 0px;
  border-radius: 16px;
  background: #ffffff;

  :deep(.van-swipe) {
    overflow: hidden;
  }
}

.card-carousel {
  margin-top: 10px;
  overflow: hidden;

  :deep(.van-swipe) {
    margin: 0;
    aspect-ratio: 933 / 585;
    height: auto !important;
  }

  :deep(.van-swipe__track),
  :deep(.van-swipe-item) {
    height: 100%;
  }
}

.swipeItem {
  box-sizing: border-box;
  padding: 0 6px;
}

.carousel-dots {
  display: flex;
  justify-content: center;
  gap: 8px;
  margin-top: 10px;

  i {
    display: block;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #d9d9d9;
  }

  .is-active {
    background: var(--wp-color-theme);
  }
}

.current-card-bar {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 15px;
  padding: 0;
  border: 0;
  border-radius: 0;
  background: transparent;
  color: #1d2129;
  text-align: left;
}

.current-card-bar__trigger {
  display: inline-flex;
  min-width: 0;
  align-items: center;
  padding: 0;
  border: 0;
  background: transparent;
  color: inherit;
  text-align: left;
}

.current-card-bar__left,
.current-card-bar__right {
  display: flex;
  align-items: center;
}

.current-card-bar__left {
  gap: 4px;

  [data-strong] {
    color: var(--wp-color-theme);
    font-size: 15px;
    font-weight: 400;
    line-height: 21px;
    white-space: nowrap;
  }
}

.current-card-bar__caret {
  width: 0;
  height: 0;
  border-top: 6px solid var(--wp-color-theme);
  border-right: 5px solid transparent;
  border-left: 5px solid transparent;
}

.current-card-bar__right {
  gap: 8px;

  em {
    padding: 1px 4px;
    border: 1px solid #f53f3f;
    border-radius: 8px;
    color: #f53f3f;
    font-size: 12px;
    font-weight: 700;
    line-height: 16px;
    font-style: normal;
  }
}

.current-card-bar__link {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  padding: 0;
  border: 0;
  background: transparent;
  color: var(--wp-color-theme);
  font-size: 13px;
  line-height: 18px;
  font-weight: 500;
}

.current-card-bar__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 25px;
  height: 25px;
  border-radius: 50%;
  background: var(--wp-color-card-3);
  flex: none;
}

.bank-card {
  position: relative;
  display: block;
  width: 100%;
  height: 100%;
  padding: 0;
  border: 0;
  background: transparent;
  color: #ffffff;
  text-align: left;

  .app-image {
    width: 100%;
    height: 100%;
    object-fit: fill;

    :deep(.van-image__img) {
      width: 100%;
      height: 100%;
      object-fit: fill;
    }
  }

  .bank-card__logo {
    position: absolute;
    top: 24px;
    left: 20px;
    width: 146px;
    height: auto;
  }

  > .course-card-label {
    position: absolute;
    top: 24px;
    left: 28px;
    color: #ffffff;
    font-size: 24px;
    font-weight: 600;
    line-height: 1.2;
    white-space: nowrap;
  }

  span {
    position: absolute;
  }
}

.bank-card__balance {
  bottom: 31px;
  left: 18px;
  font-size: 15px;
  font-weight: 700;
  line-height: 21px;
  text-shadow: 0 1px 3.8px rgba(0, 0, 0, 0.2);
}

.bank-card__scene {
  bottom: 15px;
  left: 18px;
  font-size: 10px;
  line-height: 14px;
  text-shadow: 0 1px 3.8px rgba(0, 0, 0, 0.2);
}

.bank-card__bin {
  top: 28px;
  right: 20px;
  font-size: 16px;
  font-weight: 700;
  text-shadow: 0 1px 3.8px rgba(0, 0, 0, 0.2);
}

.card-wallet__divider {
  width: 100%;
  height: 1px;
  margin-top: 28px;
  background-image: linear-gradient(
    to right,
    #d9d9d9 50%,
    rgba(255, 255, 255, 0) 0%
  );
  background-position: bottom;
  background-size: 8px 1px;
  background-repeat: repeat-x;
}

.tool-line {
  width: 100%;
  height: 1px;
  border-bottom: 1px solid #f4f5f6;
  margin-top: 10px;
  white-space: nowrap;
}

.mt-20 {
  margin-top: 20px;
}

.mb-20 {
  margin-bottom: 20px;
}

.tool-grid {
  display: grid;
  grid-template-columns: repeat(4, 60px);
  justify-content: space-between;
  column-gap: 0;
  row-gap: 10px;
  padding: 0;
  border-radius: 0;
  background: transparent;
  align-items: center;
  white-space: nowrap;
  // border: 1px soild #e0e0e0 !important;

  &-button {
    width: 60px;
    border: 0;
    background: transparent;
    color: #1d2129;
    font-size: 12px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  &-label {
    line-height: 17px;
    white-space: nowrap;
    overflow-wrap: anywhere;
    text-align: center;
  }

  .app-image {
    width: 44px;
    height: 44px;
    margin: 0 auto 6px;
  }
}

.records-card,
.empty-card {
  padding: 20px 0;
  border-radius: 16px;
  background: #ffffff;
}

.records-card header {
  display: flex;
  align-items: center;
  justify-content: space-between;

  h2 {
    margin: 0;
    color: #1d2129;
    font-size: 16px;
    font-weight: 700;
  }
}

.records-card__more {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  border: 0;
  background: transparent;
  padding: 0;
}

button,
.records-card__more span {
  border: 0;
  background: transparent;
  color: #999;
  font-size: 12px;
}

.records-card__more .app-image {
  width: 14px;
  height: 14px;
}

.records-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 30px 0 2px;

  .app-image {
    display: block;
    width: 100px;
    height: 100px;
    max-width: 100%;
    object-fit: contain;
  }

  p {
    margin: 0;
    color: #999999;
    font-size: 14px;
    line-height: 20px;
  }
}

.record-item {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  margin-top: 12px;
  padding: 12px 5px 12px 12px;
  border: 0;
  border-radius: 12px;
  background: #f4f5f6;
  color: var(--wp-color-text);
  text-align: left;

  [data-strong],
  span {
    display: block;
  }

  [data-strong] {
    font-size: 14px;
  }

  span {
    margin-top: 2px;
    color: var(--wp-color-sub-text);
    font-size: 12px;
  }

  .record-item__right {
    display: flex;
    align-items: center;
    gap: 4px;
    margin-left: auto;
  }

  .record-item__amount {
    text-align: right;

    [data-strong] {
      color: #f53f3f;
      font-weight: 700;
    }

    [data-strong].positive {
      color: #07b077;
    }
  }

  .record-item__arrow {
    flex: 0 0 auto;
    color: #86909c;
  }
}

.empty-card {
  min-height: 560px;
  text-align: center;

  .app-image {
    width: 60%;
    max-width: 230px;
    margin: 0 auto 18px;
    position: relative;
  }
  .logo {
    position: absolute;
    top: 100px;
    right: 32px;
    width: 134px;
    height: 26px;
    transform: rotate(90deg);
    object-fit: contain;
  }

  h2 {
    margin: 0;
    color: var(--wp-color-text);
    font-size: 22px;
    font-weight: 700;
  }

  p {
    margin: 12px 0 22px;
    color: #777777;
    font-size: 14px;
  }
}

.empty-card__action {
  height: 44px;
  border: 0;
  background: #202c43;
  color: #fff;
  :deep(.van-button__text) {
    // color: #ffffff;
    font-size: 16px;
    font-weight: 500;
  }
}

:global(.kyc-dialog-popup) {
  overflow: visible;
  border-radius: 12px;
  background: transparent;
}

.kyc-dialog {
  position: relative;
  box-sizing: border-box;
  width: 300px;
  padding: 34px 16px 20px;
  border-radius: 12px;
  background: #ffffff;
  text-align: center;
}

.kyc-dialog__icon {
  position: absolute;
  top: -25px;
  left: 50%;
  width: 50px;
  height: 50px;
  transform: translateX(-50%);

  :deep(.van-image__img) {
    object-fit: contain;
    border: 1px solid #fff;
  }
}

.kyc-dialog__close {
  position: absolute;
  top: 16px;
  right: 16px;
  width: 18px;
  height: 18px;
  padding: 0;
  border: 0;
  background: transparent;

  .app-image {
    width: 18px;
    height: 18px;
  }
}

.kyc-dialog h2 {
  margin: 0;
  color: #090909;
  font-size: 18px;
  font-weight: 700;
  line-height: 25px;
}

.kyc-dialog p {
  margin: 12px 0 16px;
  color: #444444;
  font-size: 16px;
  font-weight: 400;
  line-height: 22px;
}

.kyc-dialog__actions {
  display: flex;
  gap: 10px;
}

.kyc-dialog__actions button {
  flex: 1;
  height: 40px;
  padding: 0;
  border: 0;
  border-radius: 30px;
  font-size: 16px;
  font-weight: 400;
}

.kyc-dialog__cancel {
  background: var(--wp-color-button-3);
  color: var(--wp-color-theme);
}

.kyc-dialog__confirm {
  background: var(--wp-color-theme);
  color: #ffffff;
}

.pending-empty {
  padding: 12px 0 0;
}

.pending-empty__cards,
.pending-empty__notice {
  padding: 16px 14px;
  border-radius: 16px;
  background: #ffffff;
}

.pending-empty__cards {
  :deep(.van-swipe) {
    width: 100%;
    aspect-ratio: 933 / 585;
    height: auto !important;
    overflow: hidden;
  }

  :deep(.van-swipe__track),
  :deep(.van-swipe-item) {
    height: 100%;
  }

  .carousel-dots {
    margin-top: 10px;
  }
}

.pending-card {
  position: relative;
  height: 100%;
  padding: 0 5px;

  > .app-image {
    display: block;
    width: 100%;
    height: 100%;

    :deep(.van-image__img) {
      width: 100%;
      height: 100%;
      object-fit: fill;
    }
  }

  > .course-card-label {
    position: absolute;
    top: 24px;
    left: 28px;
    color: #ffffff;
    font-size: 24px;
    font-weight: 600;
    line-height: 1.2;
    white-space: nowrap;
  }
}

.pending-card__status {
  position: absolute;
  top: 0;
  right: 5px;
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 4px 12px;
  border-radius: 0 14px 0 16px;
  background: #6037b9;
  color: #f1fffc;
  font-size: 14px;
}

.pending-card__status-dot {
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: #ffffff;
}

.pending-empty__notice {
  margin-top: 12px;
  border: 1px solid var(--wp-color-card-1);
  background: var(--wp-color-card-3);
}

.pending-empty__notice-head {
  display: flex;
  align-items: center;
  gap: 5px;

  .pending-empty__notice-icon {
    position: relative;
    display: inline-flex;
    flex: 0 0 auto;
    align-items: center;
    justify-content: center;
    width: 26px;
    height: 26px;
    box-sizing: border-box;
    border-radius: 50%;
    background: var(--wp-color-brand-6);
    color: var(--wp-color-brand-1);
    font-family: Arial, sans-serif;
    font-size: 12px;
    font-weight: 700;
    font-style: normal;
    line-height: 1;

    &::before {
      position: absolute;
      width: 11px;
      height: 11px;
      border: 2px solid currentColor;
      border-radius: 50%;
      content: "";
    }
  }

  [data-strong] {
    color: #000000;
    font-size: 16px;
    font-weight: 500;
  }
}

.pending-empty__tips {
  margin: 12px 0 0;
  padding: 0;
  list-style: none;

  li {
    position: relative;
    padding-left: 11px;
    color: #666666;
    font-size: 13px;
    line-height: 20px;
  }

  li::before {
    content: "";
    position: absolute;
    left: 0;
    top: 7px;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: var(--wp-color-theme);
  }

  li + li {
    margin-top: 10px;
  }
}

.pending-empty__add {
  display: flex;
  justify-content: flex-end;
  width: 100%;
  margin-top: 10px;
  padding: 0;
  border: 0;
  background: transparent;

  .app-image {
    width: 44px;
    height: 44px;
  }
}

.pending-empty__primary {
  margin-top: 50px;
  height: 44px;
  background: var(--wp-color-brand-1);
  color: #fff;
  font-size: 16px;
  font-weight: 400;

  .icon {
    width: 20px;
    height: 20px;
  }

  :deep(.van-button__content) {
    gap: 5px;
  }
}

.pending-empty__support {
  margin-top: 12px;
  height: 44px;
  border: 0;
  background: var(--wp-color-button-2);
  font-size: 16px;
  font-weight: 400;
  .icon {
    width: 20px;
    height: 20px;
  }
  :deep(.van-button__content) {
    gap: 5px;
    color: var(--wp-color-theme);
    font-size: 16px;
  }

  .app-image {
    width: 20px;
    height: 20px;
  }
}

.floating-add-btn {
  position: fixed;
  right: 10px;
  bottom: calc(68px + env(safe-area-inset-bottom));
  z-index: 10;
  padding: 0;
  border: 0;
  background: transparent;

  .app-svg-icon {
    display: block;
    width: 60px;
    height: 60px;
  }
}

.card-picker {
  padding: 20px 0 calc(20px + env(safe-area-inset-bottom));
  background: #ffffff;
}

.card-picker__header {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;

  [data-strong] {
    font-size: 16px;
    font-weight: 500;
    color: #1d2129;
  }
}

.card-picker__close {
  position: absolute;
  top: 0;
  right: 16px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 0;
  background: transparent;

  .app-image {
    width: 18px;
    height: 18px;
    object-fit: contain;
  }
}

.card-picker__item {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  margin-top: 0;
  padding: 20px 16px;
  border: 0;
  border-radius: 0;
  background: transparent;
  color: #1d2129;
  text-align: left;

  & + & {
    border-top: 1px solid #f2f3f5;
  }

  &.active {
    background: var(--wp-color-card-3);
  }
}

.card-picker__item-left,
.card-picker__item-right {
  display: flex;
  align-items: center;
}

.card-picker__item-left {
  min-width: 0;
  gap: 8px;

  [data-strong] {
    color: var(--wp-color-brand-1);
    font-size: 15px;
    font-weight: 400;
    line-height: 21px;
  }

  span {
    color: #86909c;
    font-size: 12px;
    font-weight: 700;
    line-height: 17px;
    white-space: nowrap;
  }
}

.card-picker__item-right {
  flex: none;
  gap: 10px;

  [data-strong] {
    color: #1d2129;
    font-size: 15px;
    font-weight: 500;
    line-height: 21px;
  }
}

.card-picker__item-icon {
  width: 20px;
  height: 20px;
  object-fit: contain;
  flex: none;
}

.card-picker__check {
  width: 16px;
  height: 16px;
  object-fit: contain;
  flex: none;
}

.card-picker__check--empty {
  display: inline-block;
  border: 1px solid var(--wp-color-brand-1);
  border-radius: 50%;
  background: transparent;
}

.card-picker__item.active {
  .card-picker__item-left [data-strong],
  .card-picker__item-right [data-strong] {
    font-weight: 500;
  }
}
</style>
